(function() {
  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function init(root) {
    if (!root || root.dataset.nhInit === 'true') {
      return;
    }

    root.dataset.nhInit = 'true';

    var grid = root.querySelector('[data-articles-grid]');
    if (!grid) {
      return;
    }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-article-card]'));
    var searchInput = root.querySelector('[data-search-input]');
    var clearButton = root.querySelector('[data-clear-search]');
    var sortSelect = root.querySelector('[data-sort-select]');
    var resultSummary = root.querySelector('[data-result-summary]');
    var emptyState = root.querySelector('[data-empty-state]');
    var searchMeta = root.querySelector('[data-search-meta]');
    var searchMetaText = root.querySelector('[data-search-meta-text]');
    var searchAllLink = root.querySelector('[data-search-all-link]');
    var pageLinks = Array.prototype.slice.call(root.querySelectorAll('[data-page-link]'));
    var perPageLinks = Array.prototype.slice.call(root.querySelectorAll('[data-per-page-link]'));
    var perPageSelect = root.querySelector('[data-per-page-select]');
    var searchBase = root.getAttribute('data-search-url') || '/search';
    var backTopButton = root.querySelector('[data-back-to-top]');
    var updateTimer = null;

    function sortCards() {
      var mode = sortSelect ? sortSelect.value || 'newest' : 'newest';

      cards.sort(function(a, b) {
        var aDate = parseInt(a.getAttribute('data-date') || '0', 10);
        var bDate = parseInt(b.getAttribute('data-date') || '0', 10);
        return mode === 'oldest' ? aDate - bDate : bDate - aDate;
      });

      cards.forEach(function(card) {
        grid.appendChild(card);
      });
    }

    function updateUrl(rawQuery, sortMode) {
      if (!window.history || !window.history.replaceState) {
        return;
      }

      var url = new URL(window.location.href);

      if (rawQuery) {
        url.searchParams.set('q', rawQuery);
      } else {
        url.searchParams.delete('q');
      }

      if (sortMode && sortMode !== 'newest') {
        url.searchParams.set('sort', sortMode);
      } else {
        url.searchParams.delete('sort');
      }

      window.history.replaceState({}, '', url.toString());
    }

    function syncStateLinks(rawQuery, sortMode) {
      var query = rawQuery || '';
      var sortValue = sortMode || 'newest';

      pageLinks.forEach(function(link) {
        var href = link.getAttribute('href');
        if (!href) {
          return;
        }

        var url = new URL(href, window.location.origin);

        if (query) {
          url.searchParams.set('q', query);
        } else {
          url.searchParams.delete('q');
        }

        if (sortValue !== 'newest') {
          url.searchParams.set('sort', sortValue);
        } else {
          url.searchParams.delete('sort');
        }

        link.href = url.toString();
      });

      perPageLinks.forEach(function(link) {
        var href = link.getAttribute('href');
        if (!href) {
          return;
        }

        var url = new URL(href, window.location.origin);
        url.searchParams.delete('page');

        if (query) {
          url.searchParams.set('q', query);
        } else {
          url.searchParams.delete('q');
        }

        if (sortValue !== 'newest') {
          url.searchParams.set('sort', sortValue);
        } else {
          url.searchParams.delete('sort');
        }

        link.href = url.toString();
      });
    }

    function updateBackTop() {
      if (!backTopButton) {
        return;
      }

      backTopButton.hidden = window.scrollY < 500;
    }

    function apply(skipUrl) {
      var rawQuery = searchInput ? searchInput.value.trim() : '';
      var query = normalize(rawQuery);
      var sortMode = sortSelect ? sortSelect.value || 'newest' : 'newest';
      var visibleCount = 0;

      sortCards();

      cards.forEach(function(card) {
        var text = normalize(card.getAttribute('data-search'));
        var match = !query || text.indexOf(query) > -1;
        card.hidden = !match;
        if (match) {
          visibleCount += 1;
        }
      });

      if (clearButton) {
        clearButton.hidden = rawQuery.length === 0;
      }

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }

      root.classList.toggle('is-altered', rawQuery.length > 0 || sortMode !== 'newest');

      if (resultSummary) {
        resultSummary.textContent = rawQuery.length > 0 ? visibleCount + ' matching posts on this page' : '';
      }

      if (searchMeta && searchMetaText && searchAllLink) {
        if (rawQuery.length > 0) {
          searchMeta.hidden = false;
          searchMetaText.textContent = 'Need a broader search?';
          var url = new URL(searchBase, window.location.origin);
          url.searchParams.set('q', rawQuery);
          url.searchParams.set('type', 'article');
          url.searchParams.set('options[prefix]', 'last');
          searchAllLink.href = url.toString();
        } else {
          searchMeta.hidden = true;
          searchMetaText.textContent = '';
        }
      }

      syncStateLinks(rawQuery, sortMode);

      if (!skipUrl) {
        updateUrl(rawQuery, sortMode);
      }
    }

    function seedFromUrl() {
      var url = new URL(window.location.href);
      var query = url.searchParams.get('q');
      var sortMode = url.searchParams.get('sort');

      if (searchInput && query) {
        searchInput.value = query;
      }

      if (sortSelect && (sortMode === 'newest' || sortMode === 'oldest')) {
        sortSelect.value = sortMode;
      }
    }

    seedFromUrl();
    apply(true);
    updateBackTop();

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(function() {
          apply(false);
        }, 80);
      });
    }

    if (clearButton && searchInput) {
      clearButton.addEventListener('click', function() {
        searchInput.value = '';
        searchInput.focus();
        apply(false);
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        apply(false);
      });
    }

    if (perPageSelect) {
      perPageSelect.addEventListener('change', function() {
        var nextPerPage = perPageSelect.value;

        if (!nextPerPage) {
          return;
        }

        var url = new URL(window.location.href);
        url.searchParams.set('pp', nextPerPage);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    if (backTopButton) {
      backTopButton.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      window.addEventListener('scroll', updateBackTop, { passive: true });
      window.addEventListener('resize', updateBackTop);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-news-hub]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
